module.exports = __webpack_public_path__ + "static/media/06.b3f8df4b.png";